var _path, _path2, _path3, _path4, _path5, _rect, _circle, _circle2, _path6, _circle3, _circle4, _path7, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M21,1H3C1.8969727,1,1,1.8969727,1,3v18c0,1.1030273,0.8969727,2,2,2h18c1.1030273,0,2-0.8969727,2-2V3 C23,1.8969727,22.1030273,1,21,1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD54F",
    d: "M22,21c0,0.5512695-0.4487305,1-1,1H3c-0.5512695,0-1-0.4487305-1-1V3c0-0.5512695,0.4487305-1,1-1h18 c0.5512695,0,1,0.4487305,1,1V21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M12,5C9.7944336,5,8,6.7944336,8,9v0.5C8,9.7763672,8.2236328,10,8.5,10h2 c0.2763672,0,0.5-0.2236328,0.5-0.5V9c0-0.5512695,0.4487305-1,1-1s1,0.4487305,1,1v1.1538086 c0,0.2006836-0.1206055,0.3789063-0.3066406,0.453125C11.3608398,11.1396484,10.5,12.4111328,10.5,13.8461914V14.5 c0,0.2763672,0.2236328,0.5,0.5,0.5h2c0.2763672,0,0.5-0.2236328,0.5-0.5v-0.6538086 c0-0.2006836,0.1206055-0.3789063,0.3066406-0.453125C15.1391602,12.8603516,16,11.5888672,16,10.1538086V9 C16,6.7944336,14.2055664,5,12,5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF176",
    d: "M15,10.1538086c0,1.0234375-0.6142578,1.9306641-1.5644531,2.3105469 C12.8671875,12.6914063,12.5,13.2338867,12.5,13.8461914V14h-1v-0.1538086c0-1.0234375,0.6142578-1.9306641,1.5644531-2.3105469 C13.6328125,11.3085938,14,10.7661133,14,10.1538086V9c0-1.1030273-0.8969727-2-2-2s-2,0.8969727-2,2H9 c0-1.6542969,1.3457031-3,3-3s3,1.3457031,3,3V10.1538086z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M13,16h-2c-0.2763672,0-0.5,0.2236328-0.5,0.5v2c0,0.2763672,0.2236328,0.5,0.5,0.5h2 c0.2763672,0,0.5-0.2236328,0.5-0.5v-2C13.5,16.2236328,13.2763672,16,13,16z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 17,
    fill: "#FFF176",
    width: 1,
    height: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#303C42",
    cx: 4,
    cy: 4,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#303C42",
    cx: 20,
    cy: 4,
    r: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.1193695,
    y1: 8.888504,
    x2: 21.8221588,
    y2: 21.5912933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M14.6394653,6L14.626709,6.0075684c0.0377197,0.0331421,0.0796509,0.0613403,0.1161499,0.0958252 L14.6394653,6z M14.8966064,6.2571411C15.5759888,6.9744263,16,7.9364624,16,9v1.1538086 c0,1.4350586-0.8608398,2.706543-2.1933594,3.2392578C13.6206055,13.4672852,13.5,13.6455078,13.5,13.8461914V14.5 c0,0.2763672-0.2236328,0.5-0.5,0.5h-2c-0.1028442,0-0.1929321-0.0384521-0.2723999-0.0916138L11.8192139,16H13 c0.2763672,0,0.5,0.2236328,0.5,0.5v2c0,0.2763672-0.2236328,0.5-0.5,0.5h-2c-0.0988159,0-0.1855469-0.0359497-0.2630615-0.0853271 L13.8222656,22H21c0.5512695,0,1-0.4487305,1-1v-7.6394653L14.8966064,6.2571411z M12.6933594,10.6069336 C12.8793945,10.5327148,13,10.3544922,13,10.1538086V9c0-0.5512695-0.4487305-1-1-1s-1,0.4487305-1,1v0.5 c0,0.2763672-0.2236328,0.5-0.5,0.5h-2c-0.1361694,0-0.2588501-0.0550537-0.348938-0.1431885l2.6304321,2.6304932 C11.1356201,11.6473999,11.8061523,10.9616089,12.6933594,10.6069336z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#303C42",
    cx: 4,
    cy: 20,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#303C42",
    cx: 20,
    cy: 20,
    r: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.6523309,
    y1: 6.100121,
    x2: 24.6523304,
    y2: 17.8998795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M21,1H3C1.8969727,1,1,1.8969727,1,3v18c0,1.1030273,0.8969727,2,2,2h18 c1.1030273,0,2-0.8969727,2-2V3C23,1.8969727,22.1030273,1,21,1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlock);
export default __webpack_public_path__ + "static/media/icon_block.03381c93106c192495b51df654defd78.svg";
export { ForwardRef as ReactComponent };